import type {
  CreateSavedVenueDealRequest,
  FeedResponse,
  VenueDetail,
  VenuePublicDeal,
} from '@/lib/api/apiTypes';
import type { InfiniteData } from '@tanstack/react-query';

type RequestJSON = <T>(path: string, init?: RequestInit) => Promise<T>;

export async function toggleSavedVenueDealRequest(request: RequestJSON, deal: VenuePublicDeal) {
  if (deal.is_saved) {
    await request<void>(`/saved-deals/${deal.id}`, { method: 'DELETE' });
    return false;
  }

  await request<void>('/saved-deals', {
    method: 'POST',
    body: JSON.stringify({ deal_id: deal.id } satisfies CreateSavedVenueDealRequest),
  });
  return true;
}

export function patchFeedSavedDeal(
  data: InfiniteData<FeedResponse, number>,
  dealID: string,
  isSaved: boolean
) {
  return {
    ...data,
    pages: data.pages.map((page) => ({
      ...page,
      deals: page.deals.map((deal) => patchPublicDeal(deal, dealID, isSaved)),
      items: page.items?.map((item) =>
        item.type === 'deal' && item.deal?.deal.id === dealID
          ? {
              ...item,
              deal: {
                ...item.deal,
                deal: patchPublicDeal(item.deal.deal, dealID, isSaved),
              },
            }
          : item
      ),
    })),
  };
}

export function patchVenueDetailSavedDeal(detail: VenueDetail, dealID: string, isSaved: boolean) {
  return {
    ...detail,
    deals: detail.deals.map((deal) => patchPublicDeal(deal, dealID, isSaved)),
  };
}

function patchPublicDeal(deal: VenuePublicDeal, dealID: string, isSaved: boolean) {
  return deal.id === dealID ? { ...deal, is_saved: isSaved } : deal;
}
